// src/directives/fadeScroll.ts
export default {
  inserted(el: HTMLElement) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('appear');
          observer.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );

    el.classList.add('fade-in');
    observer.observe(el);
  },
};
